import React from 'react';
import styles from './AnnotatedPriceButton.m.sass';
import Button from '../button/Button';
import {Link} from 'react-router';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

export default class AnnotatedPriceButton extends React.PureComponent {
  render() {
    const {collapsed, price, slug} = this.props;

    return (
      <React.Fragment>
        {!collapsed ? (
          <React.Fragment>
            <ChannelPrice component="p" className={styles.price} price={price}/>
            <Button component={Link} to={`/service/${slug}`} small>Join</Button>
          </React.Fragment>
        ) : (
          <Button component={Link} to={`/service/${slug}`} price>
            <ChannelPrice price={price}/>
          </Button>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/annotatedPriceButton/AnnotatedPriceButton.js